<template>
  <div class="user">
    <div class="photo text-center">
      <md-icon style="color:white !important;">person</md-icon>
    </div>
    <div class="user-info">
      <a
          data-toggle="collapse"
          :aria-expanded="!isClosed"
          @click.stop="toggleMenu"
          @click.capture="clicked"
      >
                <span>
                    {{ user }}
                    <b class="caret"></b>
                </span>
      </a>

      <collapse-transition>
        <div v-show="!isClosed">
          <ul class="nav">
            <slot>
              <li>
                <router-link to="/login">
                                    <span
                                        style="color:red !important;"
                                        class="sidebar-mini"
                                    ><i class="material-icons text-danger"
                                    >exit_to_app</i
                                    ></span
                                    >
                  <span class="sidebar-normal">{{
                      $t("logout")
                    }}</span>
                </router-link>
              </li>
            </slot>
          </ul>
        </div>
      </collapse-transition>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      isClosed: true,
      user: '',
    };
  },
  created() {
    let user = JSON.parse(localStorage.getItem("instantcare_user"));
    this.user = user.name;
  },
  methods: {
    clicked: function (e) {
      e.preventDefault();
    },
    toggleMenu: function () {
      this.isClosed = !this.isClosed;
    }
  }
};
</script>
<style>
.collapsed {
  transition: opacity 1s;
}

.text-danger {
  color: red !important;
}
</style>
